export function applyActionOnPlotNodes(action, chartHandler, nodeIDs) {
    chartHandler.dispatchAction({
        type: action,
        dataIndex: nodeIDs,
    });
}
export function calculatePlotHeight(yPosition) {
    return `calc(100vh - ${yPosition}px)`;
}
